import React from "react";

export default function ModalAddUserNewUser(props) {

    if (gd.ac.check.company.canInviteUsers(gd.companyId)) {
        return (
            <div className="invite">
                <div className="" onClick={gd.openNew.bind(gd,'user',{type: 'invite-user', companyId: gd.companyId})}>+ Invite user</div>
            </div>
        )
    } else {
        return false;
    }
}